import { render, staticRenderFns } from "./InsuranceCard.view.vue?vue&type=template&id=1780d590&scoped=true"
import script from "./InsuranceCard.view.vue?vue&type=script&lang=js"
export * from "./InsuranceCard.view.vue?vue&type=script&lang=js"
import style0 from "./InsuranceCard.view.vue?vue&type=style&index=0&id=1780d590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1780d590",
  null
  
)

export default component.exports